import wizardStyle from "@/src/components/Form/wizardStyle";

const feedbackFormTenancyLawStyle = {
  ...wizardStyle,
  button: {
    margin: "1rem 0",
  },
};
export default feedbackFormTenancyLawStyle;
